<template>
  <div style="height: 100%;width: 100%;overflow: auto;display: flex;flex-direction: column;">
    <div v-for="(item,index) in receivePaymentList" style="border: 1px #ccc solid;margin-top: 5px">

      <div style="width: 100%;height: 30px;margin-top: 5px;display: flex;justify-content:center;">
        <div style="display: flex; align-items: center;">
          <div style="width: 100px;text-align: right;">期数：</div>
          <el-input v-model="item.paymentPhase" style="width: 200px" disabled></el-input>
          <div style="width: 200px;text-align: right">本期产品合同金额：</div>
          <div style="width: 200px;font-size: 18px;color:red;" disabled>{{formatMoney(item.paymentPhasePrice)}}</div>
<!--          <el-button type="danger" style="margin-left: 50px" @click="delPaymentLine(index)" :disabled="isDisable">删除本期明细</el-button>-->
        </div>
      </div>

      <div style="width: 100%;height:35px;display: flex;justify-content:center;">
        <div
            style="width: 1160px;display: flex;line-height: 30px;background-color: #cccccc;text-align:center;margin-top: 5px">
          <div style="width: 30px;background-color: white"></div>
          <div style="width: 30px;background-color: white"></div>
          <div style="width: 150px;">收款单号</div>
          <div style="width: 150px">计划收款日期</div>
          <div style="width: 200px">款项名称</div>
          <div style="width: 200px">计划收款金额</div>
          <div style="width: 150px">开票提醒日</div>
          <div style="width: 150px">收款提醒日</div>
          <div style="width: 100px">已收款</div>
        </div>
      </div>

      <el-scrollbar style="height: 200px;margin-top: 5px" always>
        <div v-for="(paymentInfo,payIndex) in item.paymentList" style="width: 100%;display: flex;justify-content: center">
          <div style="width: 1160px;height:35px;display: flex;line-height: 30px;margin-top: 5px;">
            <div style="width:30px;display: flex; align-items: center; justify-content: center;cursor: pointer;"
                 @click="addItemLine(index)" >
              <el-icon v-if="payIndex !== (item.paymentList.length - 1)"  :size="22">
                <CirclePlus/>
              </el-icon>
            </div>
            <div style="width: 30px;display: flex; align-items: center; justify-content: center;cursor: pointer;"
                 @click="delLine(paymentInfo,index)">
              <el-icon v-if="payIndex !== (item.paymentList.length - 1)"  :size="22">
                <Remove/>
              </el-icon>
            </div>
            <div style="width: 150px;text-align: center">
              {{paymentInfo.payment_no}}
            </div>
            <div style="width: 150px">
              <el-date-picker v-if="payIndex !== (item.paymentList.length - 1)"
                              v-model="paymentInfo.plan_payment_date" style="width: 140px" :disabled="isDisable"
                              type="date" value-format="YYYY-MM-DD"></el-date-picker>
            </div>
            <div style="width: 200px;padding: 0 5px">
              <el-input v-if="payIndex !== (item.paymentList.length - 1)" v-model="paymentInfo.payment_name"
                        style="width: 190px" :disabled="isDisable"></el-input>
              <div v-else style="width: 100%;text-align: right;font-size: 18px;color: red">本期总计: </div>
            </div>
            <div style="width: 200px;padding: 0 5px">
              <el-input-number v-if="payIndex !== (item.paymentList.length - 1)" v-model="paymentInfo.payment_price" :min="0" style="width: 190px"
                               @change="getPaymentPhasePrice" :disabled="isDisable"></el-input-number>
              <div v-else style="width: 100%;text-align: center;font-size: 18px;color: red">{{formatMoney(paymentInfo.itemSumPrice)}}</div>
            </div>
            <div style="width: 150px">
              <el-date-picker v-model="paymentInfo.invoice_remind_date" style="width: 140px" type="date" v-if="payIndex !== (item.paymentList.length - 1)"
                              value-format="YYYY-MM-DD" :disabled="isDisable"></el-date-picker>
            </div>
            <div style="width: 150px">
              <el-date-picker v-model="paymentInfo.receive_remind_date" style="width: 140px" type="date" v-if="payIndex !== (item.paymentList.length - 1)"
                              value-format="YYYY-MM-DD" :disabled="isDisable"></el-date-picker>
            </div>
            <div style="width: 100px;text-align: center" >
              <div v-if="payIndex !== (item.paymentList.length - 1)">{{paymentInfo.receive_price}}</div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div style="width: 100%;text-align: center;margin-top: 10px">
<!--      <el-button type="success"  @click="addPaymentLine" :disabled="isDisable">新增一期收款明细</el-button>-->
      <el-button type="success"  @click="reloadPaymentByProduct" v-if="!isDisable">根据产品清单重新加载</el-button>
      <el-button type="primary" style="width: 150px" @click="saveData" :disabled="isDisable">保存</el-button>
      <span v-if="isReview && !isDisable" style="margin-left: 10px;line-height: 32px;font-size: 12px">{{'(已保存)'}}</span>
    </div>

  </div>
</template>

<script>
import {CirclePlus, Remove} from "@element-plus/icons-vue";
import {nanoid} from "nanoid";

export default {
  name: "CrmReceivePaymentPlan",
  components: {CirclePlus, Remove},
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data(){
    return {
      receivePaymentList:[],
      isDisable:false,
      is_review:false,
      isReview:false

    }
  },
  computed: {

  },
  created() {
    this.initData();


  },
  methods: {
    async initData(){
      let data = await this.getCrmReceivePaymentPlan();
      if(data === true){
        return;
      }
      await this.getSaveData();
    },
    async getSaveData(){
      let list = await this.getProductPhaseAndPrice();
      if(list.length === 0){
        await this.addLine(2);
      }else {
        for (let item of list) {
          let params = {
            id:nanoid(),
            paymentPhase:'第'+item.phase+'期',
            paymentPhasePrice:item.phase_price,
            paymentList:[{id:nanoid()},{id:nanoid()}]
          };
          this.receivePaymentList.push(params);
        }
      }
      await this.loadLastItem();

    },

    async reloadPaymentByProduct(){
      this.$confirm('根据最新设置的产品清单加载对应期数的收款计划，旧数据全部初始化为空，是否确定？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.receivePaymentList = [];
        await this.getSaveData();
      });
    },

    async getCrmReceivePaymentPlan() {
      let params = {chance_id: this.parentData.id}
      let data = await this.$http('crmWinService.getReceivePaymentPlan', params);
      if (data.receivePaymentPlanList.length === 0) {
        this.receivePaymentList = [];
        this.isDisable = false;
        return false;
      } else {
        this.receivePaymentList = data.receivePaymentPlanList;
        this.isReview = data.isReview;
        await this.loadLastItem();
        //有值的情况下判断是否审核进来的，审核进来不禁用
        //成单审核状态  优先级最高
        if(this.parentData.win_review_status){
          this.isDisable = true;
          return true;
        }
        //审核窗口进来的 次之
        if (this.parentData.is_review) {
          this.isDisable = false;
          this.is_review = true;
        } else {
          this.isDisable = true;
        }
        return true;
      }
    },
    async saveData(){
      let params = {};
      let paymentPhaseList = [];
      //校验
      for(let item of this.receivePaymentList){
        let paymentPlanList = [];
        let index = this.receivePaymentList.indexOf(item);
        if (item.paymentList) {
          for (let payment of item.paymentList) {
            let itemIndex = item.paymentList.indexOf(payment);
            if(payment.payment_price == null || payment.payment_price === ''){
              // return this.$message.error('第' + (index + 1) + '期，第' + (itemIndex + 1) + '行，款项金额不能为空');
              continue;
            }
            if(!payment.plan_payment_date){
              return this.$message.error('第' + (index + 1) + '期，第' + (itemIndex + 1) + '行，计划收款日期为空');
            }
            if(!payment.payment_name){
              return this.$message.error('第' + (index + 1) + '期，第' + (itemIndex + 1) + '行，款项名称为空');
            }
            if(!payment.invoice_remind_date){
              return this.$message.error('第' + (index + 1) + '期，第' + (itemIndex + 1) + '行，开票提醒日期为空');
            }
            if(!payment.receive_remind_date){
              return this.$message.error('第' + (index + 1) + '期，第' + (itemIndex + 1) + '行，收款提醒日期为空');
            }
            paymentPlanList.push({...payment})
          }
        }
        if (paymentPlanList.length !== 0) {
          paymentPhaseList.push({id:item.id,paymentPhase:index+1,paymentPhasePrice:item.paymentPhasePrice,paymentList:paymentPlanList})
        }
      }

      params.paymentPhaseList = paymentPhaseList;
      params.chance_id = this.parentData.id;
      params.is_review = this.is_review;
      if(paymentPhaseList.length === 0){
        return this.$message.error('收款计划为空');
      }
      let check = this.checkPhasePrice();
      if(!check){
        return;
      }
      await this.$http('crmWinService.savePaymentPlan',params);
      this.$message.success('保存成功');
      await this.initData();

      let isReview = await this.$http('crmWinService.checkIsAllReview',params);
      if(isReview === true){
        this.$fn.search();
        this.$fn.closeWindow();
      }

    },
    //change事件，计算本期金额
    getPaymentPhasePrice(){
      this.receivePaymentList.forEach(item => {
        let itemSumPrice = 0;
        let productInfo = item.paymentList;
        if (productInfo) {
          productInfo.forEach(obj => {
            if(obj.payment_price !== undefined){
              itemSumPrice = itemSumPrice + obj.payment_price
            }
          });
          item.paymentList[item.paymentList.length - 1].itemSumPrice = itemSumPrice;
        }
      });
    },
    addLine(LineNum){
      for (let i = 0; i < LineNum; i++){
        this.receivePaymentList.push({
          id: nanoid(),
          paymentPhase: '第' + (i+1) + '期',
          paymentList:[{id:nanoid()},{id:nanoid()}]
        })
      }
    },
    addPaymentLine(){
      this.receivePaymentList.push({
        id: nanoid(),
        paymentPhase: '第' + (this.receivePaymentList.length + 1) + '期',
        paymentList:[{id:nanoid()}]
      })
    },
    delPaymentLine(index){
      if(this.receivePaymentList.length === 1){
        return;
      }
      this.receivePaymentList.splice(index,1);
      this.receivePaymentList.forEach((item,index)=>{
        item.paymentPhase = '第' + (index + 1) + '期'
      })
    },
    addItemLine(index){
      if(this.isDisable === true){
        return;
      }
      this.receivePaymentList[index].paymentList.push({
        id: nanoid()
      })
    },
    delLine(itemNode,index){
      if(this.isDisable === true){
        return;
      }
      if(this.receivePaymentList[index].paymentList.length === 1){
        return;
      }
      let delId = itemNode.id
      this.receivePaymentList[index].paymentList.forEach(item => {
        if(delId === item.id){
          this.receivePaymentList[index].paymentList.splice(this.receivePaymentList[index].paymentList.indexOf(item),1)
        }
      })
    },

    loadLastItem(){
      for(let paymentItem of this.receivePaymentList){
        paymentItem.paymentList.push({id:nanoid()});
      }
      this.getPaymentPhasePrice();
    },

    async getProductPhaseAndPrice(){
      let params = {chance_id:this.parentData.id};
      let list = [];
      list = await this.$http('crmWinService.getProductPhaseAndPrice', params);
      return list;
    },
    checkPhasePrice(){
      for (let item of this.receivePaymentList) {
        let phasePrice = item.paymentPhasePrice;
        let payItemList = item.paymentList;
        let itemSumPrice = payItemList[payItemList.length - 1].itemSumPrice;
        if(phasePrice !== itemSumPrice){
          this.$message.error(item.paymentPhase+'，产品合同金额与收款计划总计金额不一致');
          return false;
        }
      }
      return true;
    },
    //将数字转换成金额显示
    formatMoney(num) {
      if(num === undefined || num === ''){
        return '0';
      }
      num = num.toFixed(2);
      num = parseFloat(num)
      num = num.toLocaleString();
      return num;//返回的是字符串23,245.12保留2位小数
    },

  }
}
</script>

<style scoped>

</style>